export default __webpack_public_path__ + "static/0194-887728f3b7f699b5d2645de88c91d664.png";